import React, { useState } from "react";
import { failedRows, successRows } from "../texts/results"
import { useSelector } from "react-redux";

const ResultsCard = () => {
    const fileDetails = useSelector(state => state.fileDetails);
    const [showModal, setShowModal] = useState(true);
    const error = fileDetails.failedRows;
    return (
        <div>
            {showModal && (
                <div className="card">
                    <div className="card-body">
                        <div style={{ paddingBottom: '30px' }}>
                            <h3 className="pt-5">הקובץ נקלט בהצלחה</h3>
                            <img src="checked.png" alt="" className="pt-5" style={{ width: '100px' }} />
                            <div className="pt-5">{successRows}: {fileDetails.enteredRows}</div>
                            {error > 0 &&
                                <div className="pt-5">{failedRows}: {error}</div>
                            }
                        </div>
                        <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>אישור</button>
                    </div>
                </div>)}
        </div>
    )
};

export default ResultsCard;